import type { ComponentProps } from 'react';
import { cn } from '../lib/cn';
import { fieldClasses } from './field-styles';
import { Icon, type IconName } from './icon';

export interface InputProps extends ComponentProps<'input'> {
  /** Icon inside the field on the left, e.g. `search`. */
  icon?: IconName;
}

export function Input({ icon, className, type = 'text', ...props }: InputProps) {
  const input = (
    <input
      type={type}
      className={cn(fieldClasses, 'h-control px-3', icon && 'pl-9', className)}
      {...props}
    />
  );
  if (!icon) return input;
  return (
    <div className="relative w-full">
      <Icon
        name={icon}
        className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-fg-subtle"
      />
      {input}
    </div>
  );
}

export function Textarea({ className, rows = 4, ...props }: ComponentProps<'textarea'>) {
  return (
    <textarea
      rows={rows}
      className={cn(fieldClasses, 'min-h-control resize-y px-3 py-2', className)}
      {...props}
    />
  );
}
